
<svelte:head>
  <title>Chi Sono - Dott.ssa Eleonora Ceroni Psicologa Faenza</title>
  <meta name="description" content="Sono la Dott.ssa Eleonora Ceroni, psicologa clinica e psicoterapeuta cognitivo-costruttivista in formazione a Faenza." />
  
</svelte:head>



<section id="chi-sono" class="about-me">
  <div class="content">
    <div class="bio">
      <h2><span>Dott.ssa</span><span>Eleonora Ceroni</span></h2>
      <h3 class="subtitle">Psicologa Clinica</h3>
      <p>
        Sono la dott.ssa Eleonora Ceroni, <strong>psicologa clinica</strong> e <strong>psicoterapeuta cognitivo-costruttivista</strong> in formazione.

Ho conseguito la laurea triennale in Scienze e Tecniche Psicologiche e la laurea Magistrale in Psicologia Clinica presso l’università di Cesena. Sono regolarmente iscritta alla sezione A dell’Albo degli Psicologi della Regione Emilia Romagna con il numero 10935. Attualmente mi sto specializzando presso la Scuola Bolognese di Psicoterapia Cognitiva (SBPC).<br>

<br>Il mio approccio integra l’applicazione delle tecniche cognitivo-comportamentali ad una <strong>visione sensibile e unica</strong> dell’individuo, del suo percorso evolutivo e delle sue risorse. Credo fermamente nel <strong>potere terapeutico della relazione</strong>, nell’unicità dell’individuo e nel suo bisogno di sentirsi accolto, ascoltato e compreso nella globalità e nella complessità delle sue irripetibili caratteristiche. Il mio obbiettivo è quello di <strong>personalizzare il percorso</strong> adattandolo ai bisogni, ai tempi e alle peculiarità dell’individuo.<br>

<br>Sono da sempre convinta che la terapia sia un dono: offrire ad una persona la possibilità di dare senso alla sua storia, ai suoi sogni e alle sue delusioni attraverso uno sguardo e una <strong>consapevolezza</strong> nuovi. Entrare in contatto con le parti più profonde di sé e scorgere la propria <strong>autenticità</strong> in tutta la sua <strong>fragilità</strong>.<br>

<br>Mi piace immaginare lo spazio terapeutico come un <strong>luogo sicuro</strong> in cui sentirsi accolti senza giudizio. Un luogo libero dove poter esprimere sé stessi in modo autentico. Un luogo protetto dove affidare la propria storia.<br>
<strong>Amo ascoltare storie, darle luce e creare spazio interiore.</strong>
      </p>
    </div>
    <div class="photo">
      <img src="IMG_8093.JPG" alt="Eleonora Ceroni Psicologa - Faenza" />
    </div>
  </div>
</section>

<style>
  :root {
    /* Assicurati che questa variabile sia definita o sostituisci il colore */
    --primary-color: #007bff; /* Esempio di colore primario */
  }

  .about-me {
    padding: 1rem 2rem;
    background-color: white;
    box-shadow: 0 0 20px rgba(0,0,0,0.1);
    margin: 2rem 0;
    border-radius: 10px;
  }

  .content {
    display: flex;
    /* align-items: flex-start;  Rimuovi o commenta questa riga se presente */
    align-items: center; /* Aggiungi o modifica questa riga */
    max-width: 1200px;
    margin: 0 auto;
  }

  .bio {
    flex: 2;
    padding-right: 2rem;
  }

.bio p {
    font-size: 1.1rem; /* Esempio: aumenta la dimensione del font. Scegli la misura che preferisci (es. 16px, 1.2em, ecc.) */
    line-height: 1.7;  /* Aumenta l'interlinea per una migliore leggibilità con font più grandi */
    color: #333;       /* Puoi anche definire un colore per il testo se vuoi */
  }

  .photo {
    flex: 1;
    display: flex;
    justify-content: flex-end;
  }

   .photo img {
    width: 350px;
    height: 350px;
    border-radius: 50%; /* Cerchio perfetto */
    object-fit: cover;
  }

  .about-me h2 {
    color: var(--accent-color);
    margin-bottom: 1rem;
    font-size: 3.0rem;
    line-height: 1.2; /* Line height standard per h2 */
  }
  .about-me h2 span { /* Su desktop, gli span sono inline */
    display: inline;
  }
  .about-me h2 span:not(:last-child)::after { /* Aggiunge uno spazio tra gli span su desktop */
    content: " ";
  }

  .about-me h3.subtitle {
    color: var(--accent-color); /* Stesso colore di H2 */
    font-size: 2.0rem;        /* Stessa grandezza di H2 */
    font-family: inherit;     /* Stesso font (ereditato o specifico se H2 lo ha) */
    font-weight: bold;        /* Stesso peso (H2 è bold di default) */
    margin-bottom: 1rem;      /* Margine simile a H2 */
    line-height: 1.2;         /* Line height simile a H2 */
  }


  @media (max-width: 768px) {
    .content {
      flex-direction: column;
      align-items: center; /* Centra gli item in colonna su mobile */
    }

    .bio {
      padding-right: 0;
      padding-bottom: 1rem; /* Leggermente ridotto per compensare il minor spazio */
      order: 2; /* Bio viene dopo la foto su mobile */
      width: 100%; /* Per permettere il text-align center di funzionare bene */
      text-align: center; /* Centra il testo dei titoli su mobile */
    }
    .bio p {
      text-align: left; /* Mantiene i paragrafi allineati a sinistra per leggibilità */
      margin-top: 1rem;
font-size: 1.1rem;
    }

    .photo {
      justify-content: center;
      order: 1; /* Foto viene prima del bio su mobile */
      margin-bottom: 1.5rem; /* Spazio tra foto e bio */
      margin: 2rem
    }
    .photo img {
      width: 240px; /* Dimensione foto ridotta per mobile */
      height: 240px;
    }

    .about-me h2 {
      font-size: 2.5 rem; /* Dimensione font H2 ridotta per mobile */
      line-height: 1.15;  /* Line height leggermente ridotta per le 3 righe */
      margin-bottom: 0.3rem; /* Margine inferiore ridotto */
    }
    .about-me h2 span {
      display: block; /* Ogni span su una nuova riga */
    }
    .about-me h2 span:not(:last-child)::after { /* Rimuove lo spazio tra gli span su mobile */
      content: "";
    }

    .about-me h3.subtitle {
      font-size: 1.8rem; /* Stessa dimensione di H2 su mobile */
      margin-bottom: 2rem; /* Margine inferiore per H3 su mobile */
      line-height: 1.2; /* Line height standard per H3 */
    }
  }
</style>